import { IVirtualizedListStyle } from '../models/index.js';
export const virtualizedListStyle: IVirtualizedListStyle = {
	children: {
		wrapper: {
			height: 'calc(100vh - 30px)',
		},
	},
};
